// F-AC: a whole-day picker for filters (stats page, Log). It shows the fixed
// "YYYY-MM-DD" DateField (the browser's locale never changes how a date
// looks) and reports a day only once the text is a real date, so half-typed
// text never reaches a query. Days are Hong Kong calendar days — the caller's
// label says "(HKT)". Without `allowEmpty` a cleared box is marked invalid
// like half-typed text: the page keeps using the last real day.

import { useEffect, useState, type FC } from "react";

import DateField from "@staff/components/DateField";
import { parsePeriodDate } from "@shared/lib/period";

export interface DayPickerProps {
  /** "YYYY-MM-DD", or "" for no day. */
  value: string;
  /** A real day, or "" when the box is cleared and `allowEmpty` is set. */
  onChange: (day: string) => void;
  ariaLabel: string;
  testId: string;
  allowEmpty?: boolean;
}

const DayPicker: FC<DayPickerProps> = ({
  value,
  onChange,
  ariaLabel,
  testId,
  allowEmpty = false,
}) => {
  const [text, setText] = useState(value);
  useEffect(() => setText(value), [value]);

  const handleChange = (next: string) => {
    setText(next);
    const day = parsePeriodDate(next);
    if (day) onChange(day);
    else if (allowEmpty && next.trim() === "") onChange("");
  };

  return (
    <DateField
      value={text}
      onChange={handleChange}
      invalid={
        text.trim() === "" ? !allowEmpty : parsePeriodDate(text) === null
      }
      ariaLabel={ariaLabel}
      testId={testId}
    />
  );
};

export default DayPicker;
